import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { buttons } from 'seal-ui-components';
import mixpanelEvents from '@Mixpanel';
import BoldLabel from '@Components/UI/Label';
import BarChart from '@Components/UI/BarChart/BarChart';
import { setRiskFlags, resetAllFilterFlags } from '@Actions/filterActions';
import { QuickFilterWrapper, QuickFilterHeader } from '../ScoreCardFilters.style';

const QuickFilter = () => {
    const dispatch = useDispatch();

    const { riskFlagsInput, activeFilters } = useSelector(state => state.scoreCardFilters);

    const selectedValues = Object.values(riskFlagsInput).filter(flag => flag.selected).length;

    const onBarClickHandler = (key, allValuesSelected) => {
        if (allValuesSelected) {
            Object.values(riskFlagsInput).forEach(item => {
                riskFlagsInput[key].text !== item.text && (item.selected = false);
            });
        } else if (selectedValues === 1 && riskFlagsInput[key].selected === true) {
            Object.values(riskFlagsInput).forEach(item => {
                item.selected = true;
            });
        } else {
            riskFlagsInput[key].selected = !riskFlagsInput[key].selected;
        }

        dispatch(setRiskFlags(riskFlagsInput));
        mixpanelEvents.scorecardFiltersBarChart();
    };

    const resetOnClickHandler = () => {
        dispatch(resetAllFilterFlags());
        mixpanelEvents.scorecardFiltersReset();
    };

    const dataset = Object.keys(riskFlagsInput)
        .filter(key => riskFlagsInput[key].count !== 0)
        .map(key => riskFlagsInput[key]);

    const allSelected = dataset.filter(d => d.selected).length === dataset.length;
    const curActiveFilters = !!Object.values(activeFilters).filter(filter => filter.active).length;

    return (
        <>
            <QuickFilterWrapper>
                <QuickFilterHeader>
                    <BoldLabel>Filter and sorting</BoldLabel>
                    {curActiveFilters && (
                        <buttons.Button
                            size="medium"
                            appearance="secondary"
                            data-testid="scorecard_filter_reset_button"
                            onClick={() => resetOnClickHandler()}
                        >
                            Reset
                        </buttons.Button>
                    )}
                </QuickFilterHeader>
                <BarChart
                    dataset={dataset}
                    allSelected={allSelected}
                    onBarClick={value => onBarClickHandler(value, allSelected)}
                    size={{ width: 350, height: 125 }}
                    xLabel="Number of subtopics"
                />
            </QuickFilterWrapper>
        </>
    );
};

export default QuickFilter;
